import * as React from 'react';
const SvgCheckWhite = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 13, height: 12, fill: "none" }, props),
    React.createElement("path", { stroke: "#fff", strokeWidth: 2, d: "m1 5 4.117 5L12 1.5" })));
export default SvgCheckWhite;
